import { Component, HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';


export interface Feature {
  icon: string;
  title: string;
}

export interface Work {
  img: string;
  title: string;
  category: string;
}

export interface Service {
  icon: string;
  title: string;
  desc: string;
}

export interface Blog {
  image: string;
  title: string;
  category: string;
  color: string;
  time: string;
}

@Component({
  standalone: false,
  selector: 'app-home-two',
  templateUrl: './home-two.component.html',
  styleUrl: './home-two.component.css'
})
export class HomeTwoComponent {
  // OWl Slider
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  slideStore = [
    {
      title: ".Design Lab",
      subtitle: "Digital Production",
      subtitleTwo:"Chaos Agency",
      image: "assets/images/slides/slide-1.jpg",
      callUs:[
        {
          phone: "Call Us (0123) 456 - 7890",
          queryDesc: "For any query or concern"
        }
      ]
    },

    {
      title: "Design Studio",
      subtitle: "A Chaos Web Agency.",
      image: "assets/images/slides/slide-2.jpg"
    }

  ];

  //Features
  features: Feature[] = [
    { icon: 'bi-boxes', title: 'Creative Design' },
    { icon: 'bi-brilliance', title: 'Development' },
    { icon: 'bi-exclude', title: 'Implementation' },
    { icon: 'bi-earbuds', title: 'Live Support' }
  ];

  // Works
  works:Work[] =[
    {
      img:'1.jpg',
      title:'Amazing Illustration',
      category:'Web'
    },
    {
      img:'2.jpg',
      title:'Flyer Design',
      category:'Graphic'
    },
    {
      img:'3.jpg',
      title:'Dafur Dagegen',
      category:'Brand'
    },
    {
      img:'4.jpg',
      title:'Motherlands Cars',
      category:'Graphics'
    },
    {
      img:'5.jpg',
      title:'T-shirt Design',
      category:'Wordpress'
    },
    {
      img:'6.jpg',
      title:'Business Cards',
      category:'Graphic'
    }
  ];

  //Services
  services: Service[] = [
    {
      icon: 'bi-laptop purple-color',
      title: 'Responsive',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-exclude color-primary',
      title: 'Development',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-gear blue-color',
      title: 'Implementation',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-chat-dots-fill green-color',
      title: 'Live Support',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-layers-fill yellow-color',
      title: 'Pixel Perfect',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    },
    {
      icon: 'bi-trophy-fill brown-color',
      title: 'Award Winning',
      desc:'Integer purus ipsum, auctor vitae posuere et, consectetur ac leo. Pellentesque sit amet risus sagittis, fermentum ligula.',
    }
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // OWl Slider
  testimonialOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 2,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  testimonials = [
    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-4.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-5.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-6.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-1.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }
  ];

  //Blogs
  posts: Blog[] = [
    {
      image: 'assets/images/blogs/post-01.jpg',
      title: 'Kobe Steel plant that supplied plane components being checked',
      category: 'News',
      color: 'purple-color',
      time: '7 hours ago'
    },
    {
      image: 'assets/images/blogs/post-02.jpg',
      title: 'They say that a picture is worth a thousand words',
      category: 'Events',
      color: 'pink-color',
      time: 'Yesterday'
    },
    {
      image: 'assets/images/blogs/post-03.jpg',
      title: 'NewsBike | NY News Satire, Parody and Spoof News',
      category: 'Blog',
      color: 'blue-color',
      time: 'December 21, 2024'
    }
  ];
}
